<template>
  <frontPage/>
  <div>
    <h1>Forum Users</h1>
    <ul>
      <li v-for="user in users" :key="user.id">
        {{ user.username }} - {{ user.email }} <!-- Display username and email; adjust according to available fields -->
      </li>
    </ul>
  </div>
</template>

<script>
import axios from 'axios';
import frontPage from './frontPage.vue';
export default {
  components: {
    frontPage
  },
  data() {
    return {
      users: []  // Array to store user data
    };
  },
  methods: {
    fetchUsers() {
      const apiUrl = 'https://18.118.123.239/4200';  // Replace with your Discourse domain
      const apiKey = '0c9361df7c49d0da3725edd303bf4ca031e568dbac3adeb6496c3f33b3711fdb';  // Replace with your actual API key
      const apiUsername = 'mitchell_wo';  // Replace with your Discourse username

      axios.get(`${apiUrl}/admin/users/list/active.json`, {  // Adjust endpoint if needed
        headers: {
          'Api-Key': apiKey,
          'Api-Username': apiUsername
        }
      })
      .then(response => {
        this.users = response.data;  // Assuming the API returns an array of users
        console.log('Users fetched successfully:', this.users);
      })
      .catch(error => {
        console.error('Error fetching users from Discourse:', error);
      });
    }
  },
  mounted() {
    this.fetchUsers();  // Fetch users when component mounts
  }
};
</script>

<style>
/* Add styles if needed */
</style>
